module.exports = __webpack_public_path__ + "img/chat-pin.7839b0d9.svg";